// Distance-unit helpers for the admin panel. Region docs store mixed canonical
// units (`radiusKm` in km, `conflictRadiusMiles` in miles); we keep that storage
// untouched and convert only for *display*, picking miles vs km from the region's
// own country so a region's two radii always read in one unit.

export const MI_TO_KM = 1.609344;
export const KM_TO_MI = 1 / MI_TO_KM;

// Countries that show road distances in miles. Matched against both ISO codes
// (region `geocodeStateFilter.country`, e.g. "US") and long names, so the check
// is representation-agnostic.
const MILE_COUNTRIES = new Set([
  "US", "USA", "UNITED STATES", "UNITED STATES OF AMERICA",
  "GB", "UK", "UNITED KINGDOM", "GREAT BRITAIN",
  "MM", "MYANMAR", "BURMA",
  "LR", "LIBERIA",
]);

// "mi" | "km" for a region/country. Unknown/empty → "mi" (US-first default).
export function unitForCountry(country) {
  const c = (country || "").trim().toUpperCase();
  if (!c || c === "UNKNOWN") return "mi";
  return MILE_COUNTRIES.has(c) ? "mi" : "km";
}

// km canonical <-> display unit.
export const kmToUnit = (km, unit) => (unit === "km" ? km : km * KM_TO_MI);
export const unitToKm = (val, unit) => (unit === "km" ? val : val * MI_TO_KM);

// miles canonical <-> display unit.
export const milesToUnit = (mi, unit) => (unit === "km" ? mi * MI_TO_KM : mi);
export const unitToMiles = (val, unit) => (unit === "km" ? val * KM_TO_MI : val);

// Round to `dp` decimals for tidy display, in a way that round-trips cleanly
// back through the canonical value (integers for catchment, 1dp for conflict).
export const roundDisplay = (n, dp = 0) => {
  if (!Number.isFinite(n)) return n;
  const f = 10 ** dp;
  return Math.round(n * f) / f;
};
